import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'account-service-restrictions' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
